import { ModalStyled } from './modal.styled';
import Button from '../../../../base/button/button';
import i18n from 'i18next';
import { ModalIcon, ModalTitle, ModalVariant } from './modal.constants';
import EditText from '../../../../base/edit-text/edit-text';
import React, { useState } from 'react';
import { SvgImage, SvgType } from '../../../../base/svg/svg';

export interface ModalProps {
  variant: ModalVariant;
  handleClose: () => void;
  onConfirmClick: any;
  message: null | string;
  title?: string;
  secondMessage?: string;
}

const Modal = (props: ModalProps) => {
  const [message, setMessage] = useState('');

  return (
    <ModalStyled.StyledModal open={!!props.message} onClose={props.handleClose}>
      <ModalStyled.StyledBox sx={{ width: 400 }}>
        <ModalStyled.ContainerContent>
          <ModalStyled.ContainerCloseButton onClick={() => props.handleClose()}>
            <SvgImage type={SvgType.Close} />
          </ModalStyled.ContainerCloseButton>
          {ModalIcon[props.variant]}
          <ModalStyled.Title>
            {props.title ? props.title : ModalTitle[props.variant]}
          </ModalStyled.Title>
          <ModalStyled.Description>{props.message}</ModalStyled.Description>
          <ModalStyled.Description>
            {props.secondMessage}
          </ModalStyled.Description>
          {(props.variant === ModalVariant.WarningTextPicker ||
            props.variant === ModalVariant.PlainTextPicker) && (
            <>
              <ModalStyled.TextFieldContainer>
                <EditText
                  placeholder={i18n.t('sendEmail.message')}
                  onChange={(text: any) => setMessage(text.target.value)}
                  label={i18n.t('sendEmail.insertMessage')}
                  multiline
                />
              </ModalStyled.TextFieldContainer>
              <ModalStyled.Separator />
            </>
          )}
        </ModalStyled.ContainerContent>
        <ModalStyled.ContainerButton>
          <ModalStyled.Button>
            {(props.variant === ModalVariant.ConfirmationRequest ||
              props.variant === ModalVariant.WarningTextPicker ||
              props.variant === ModalVariant.PlainTextPicker) && (
              <Button
                onClick={() => props.onConfirmClick(message)}
                label={i18n.t('common.confirm')}
              />
            )}
            {(props.variant === ModalVariant.Success ||
              props.variant === ModalVariant.Error) && (
              <Button
                onClick={() => props.handleClose()}
                label={i18n.t('common.ok')}
              />
            )}
          </ModalStyled.Button>
        </ModalStyled.ContainerButton>
      </ModalStyled.StyledBox>
    </ModalStyled.StyledModal>
  );
};

export default Modal;
